import { useFormContext } from 'react-hook-form'
import { LightTooltip, findInputError, isFormInvalid, InputError } from '.'
import {useState} from "react";

export const TextArea = ({
                             lable_text,
                             type,
                             name,
                             placeholder,
                             validation,
                             tooltip_title,
                             hasError,
                             disable,
                             direction}) => {

    const { register, formState: { errors } } = useFormContext()
    const [firstTime, setFirstTime] = useState(true)
    const textAreaRegister = register(name, validation);
    
    const inputError = findInputError(errors, name)
    const isInvalid = isFormInvalid(inputError)

    return(
        <div className='row justify-content-center my-4'>
            <div className='col-12 col-md-5'>

                <label className="form-label text-form-title"  
                >{lable_text}</label>
                {validation ? <span className='required-label'>
                    *
                </span> : ''}

                {tooltip_title ? <LightTooltip tooltip_title={tooltip_title} /> : ''}

                <textarea 
                    disabled={disable ? true : false} 
                    type={type} 
                    name={name}
                    rows={4} 
                    className={`form-control text-form-input 
                        ${direction=="ltr" ? "text-start" : null} 
                        ${isInvalid ? "form-control-error" : null}
                        ${firstTime && hasError == 'error' ? "form-control-error" : null}
                        ${firstTime && hasError == 'correct' ? "form-control-correct" : null}
                    `}
                    placeholder={placeholder}
                    {...textAreaRegister}
                    onChange={ (e) => {
                        if(!disable){
                            textAreaRegister.onChange(e)
                            setFirstTime(false)
                        }
                    }}
                    style={{"border":
                        isInvalid ? "1px solid red" 
                        : "1px solid hsl(0, 0%, 80%)"
                    }}     
                />

                {isInvalid && (
                    <InputError
                    message={inputError.error.message} show={true}
                    />
                )}

            </div>
        </div>
    )
} 